/**
 * Per-seat LKR from Directus `buses.fee`.
 */
export function getSeatPriceLkr(bus) {
  const n = Number.parseFloat(String(bus?.fee ?? "").trim());
  if (!Number.isFinite(n) || n < 0) return 0;
  return n;
}

export function getBookingTotalLkr(bus, seatCount) {
  const count = Math.max(0, Number(seatCount) || 0);
  return getSeatPriceLkr(bus) * count;
}
